import React, { useState } from "react"
import { connect } from "react-redux"
import { Form as BootstrapForm } from "react-bootstrap"
import { Tooltip } from "@material-ui/core"
import BootstrapToggle from "react-bootstrap-toggle"
import { FormikProps } from "formik/dist/types"
import {
  getAvailableMissionCodes,
  isRoutineButtonDisabled,
} from "../../../helpers/configurationHelper"
import {
  changeRoutineStatusAction,
  resetSearchAction,
  setMissionAction,
} from "../../../state/application/actions"
import {
  changeRoutineStatusActionGeomap,
  removeKMLGuideShapeAction,
  removeLastShapeAction,
  setSearchMode
} from "../../../state/geoMap/actions"
import { hasBeenFilled } from "../../../helpers/dynamicFormHelper"
import { AdvancedSearchConfigurationsType } from "../../../types/configurations"
import { ShapeType } from "../../../types/shape"
import { DEFAULT_TOOLTIP_PROPS } from "../../../helpers/tooltipHelper"
import translations from "../../../translations"
import {AppParametersType} from "../../../types/app";

interface PropsType {
  formProps: FormikProps<any>,
  language: string,
  appParameters: AppParametersType
}

const InvalidateField = (props: PropsType) => {
  const {
    formProps,
    language,
    appParameters
  } = props;

  const { values, setFieldValue, resetForm } = formProps
  const value = values.invalidate_mode
  const isInputDisabled = false;

  let switchElement = (
    <BootstrapToggle
      id="invalidate_mode"
      name="invalidate_mode"
      disabled={isInputDisabled}
      onClick={(invalidate_mode) => {
        resetForm()
        setFieldValue("invalidate_mode", !!invalidate_mode)
      }}
      on={translations("invalidate_mode_invalidate", language)}
      onClassName="invalidate_mode-switch-invalidate"
      off={translations("invalidate_mode_validate", language)}
      offClassName="invalidate_mode-switch-validate"
      handleClassName="invalidate_mode-switch"
      active={value}
      height="28px"
      width="147px"
    />
  )

  if (isInputDisabled) {
    switchElement = (
      <Tooltip
        {...DEFAULT_TOOLTIP_PROPS}
        title={translations("invalidate_modeNotAvailable", language)}
        placement="top"
      >
        {switchElement}
      </Tooltip>
    )
  }

  return (
    <div className="row mx-0 mb-3">
      <BootstrapForm.Label className="col-3 m-0 px-0 d-flex">
        <span style={{ textOverflow: "inherit" }}>
          *
          {translations("invalidateModeLeftSearchBar", language)}
        </span>
      </BootstrapForm.Label>
      <BootstrapForm.Group className="col-9 m-0 pr-0 switch-container d-flex justify-content-end">
        {switchElement}
      </BootstrapForm.Group>
    </div>
  )
}

const mapStateToProps = (state) => ({
  configurations: state.application.configurations,
  loadingInitialData: state.application.loadingInitialData,
  language: state.application.appParameters.language,
  appParameters: state.application.appParameters,
})

const mapDispatchToState = (dispatch) => ({

})

export default connect(mapStateToProps, mapDispatchToState)(InvalidateField)
